
export const BASE_URL = "https://gipamcdata.com/api";
// export const BASE_URL = "http://localhost:3500";

export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  CHANGE_PASSWORD: "/auth/change_password",
  TRUCKS: "/trucks",
  GENERATE_XML_FILE: "/generate_xml_file",
};
